export const DimensionMap = {
  ALL: '所有',
  campaignId: '推广计划ID',
  adId: '广告ID',
  pageId: '落地页ID',
  componentId: '组件ID',
  wechatSpid: '微信服务商ID',
};

export const getDimension = (str) => {
  if (DimensionMap[str]) {
    return DimensionMap[str];
  }
  return '未知';
};
export const STATUS = {
  SUCCESS: 0,
  FAIL: 1,
  PENDING: 2,
  INIT: 3,
};

export const FIELD = {
  account_id: '广告主帐号id',
  leads_id: '线索id',
  click_id: '广告点击id',
  account_type: '账号类型，包含1表示广点通 2表示微信',
  advertiser_id: '广告主id：广点通广告主id=account_id,微信广告主id=微信账户appid',
  wechat_appid: '微信服务商id',
  agency_id: '服务商id 广点通服务商服务商id,微信服务商=服务商spid',
  agency_name: '服务商名称',
  wechat_spid: '微信服务商id',
  campaign_id: '推广计划id',
  campaign_name: '推广计划名称',
  adgroup_id: '广告id',
  adgroup_name: '广告名称',
  component_id: '组件id',
  component_name: '组件名称',
  page_id: '落地页id',
  page_url: '落地页url',
  page_name: '落地页名称',
  leads_type: '线索类型',
  leads_sub_type: '二级线索类型',
  leads_tags: '线索标签',
  leads_name: '姓名',
  leads_tel: '电话',
  tel_location: '号码归属地',
  leads_area: '所在地',
  leads_email: '邮箱',
  leads_qq: 'qq号',
  leads_wechat: '微信号',
  leads_gender: '性别',
  leads_potential_score: '线索评分',
  leads_follow_tag: '标签',
  leads_create_time: '线索入库时间',
  leads_action_time: '线索提交时间',
  leads_source: '线索来源',
  creative_id: '创意id(待废弃)',
  creative_name: '创意名称(待废弃)',
  ad_id: '投放端的广告创意ID',
  ad_name: '投放端的广告创意名称',
  adcreative_id: 'mkt api 创意id',
  adcreative_name: 'mkt api 创意名称',
  nationality: '国籍',
  working_years: '工作年限',
  age: '年龄',
  profession: '职业',
  id_number: '身份证号码',
  address: '详细地址',
  leads_convert_status: '线索转化状态',
  shop_name: '门店名称',
  shop_address: '门店地址',
  leads_touch_tag: '接通状态',
  call_middle_num: '智能电话中间号',
  call_consumer_hotline: '智能电话-客服电话',
  call_touch_tag: '智能电话-接通状态',
  call_duration: '智能电话-通话时长',
  call_record_url: '智能电话-通话录音链接',
  leads_pool_id: '鹅房通楼盘ID',
  chat_id: '智能咨询-会话ID',
  layer_form_content: '蹊径意向表单',
  nick_name: '微信昵称',
  is_broad_cast_leads: '多发线索',
  custom_qa: '互动内容', // add by fightingliu 二期
  owner_name: '当前归属人',
  all_follow_records: '全部跟进记录'
};
